import { render, staticRenderFns } from "./CompanyContractorAdminCard.vue?vue&type=template&id=2ce1cdfb"
import script from "./CompanyContractorAdminCard.vue?vue&type=script&lang=ts"
export * from "./CompanyContractorAdminCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce1cdfb')) {
      api.createRecord('2ce1cdfb', component.options)
    } else {
      api.reload('2ce1cdfb', component.options)
    }
    module.hot.accept("./CompanyContractorAdminCard.vue?vue&type=template&id=2ce1cdfb", function () {
      api.rerender('2ce1cdfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/CompanyContractorAdminCard.vue"
export default component.exports